import { useQuery } from "@tanstack/react-query";

import { getTimesheet } from "@/adapters/api";
import { useActiveContext } from "@/store/use-active-context";
import type { Timesheet } from "../types";
import { toTimesheet } from "../utils/map";

export function useTimesheet(month: string) {
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);

	return useQuery({
		queryKey: ["attendance", "timesheet", activeCanteiroId, month],
		enabled: activeCanteiroId != null,
		queryFn: async (): Promise<Timesheet> =>
			toTimesheet(await getTimesheet(activeCanteiroId as string, month)),
		staleTime: 30_000,
	});
}
